<template>
    <div class="modal fade" :id="id" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <form v-on:submit="submit">
                    <div class="modal-header d-flex justify-content-between">
                        <h5 class="modal-title fw-bold text-black">{{ $t('feature.surveys.$steps.add') }}</h5>
                        <button class="bg-transparent border-0 close-btn lh-1 p-10 text-muted" type="button"
                            data-bs-dismiss="modal" @click="restoreData()">
                            <i class="ph-bold ph-x"></i>
                        </button>
                    </div>
                    <div class="modal-body">
                        <StepForm v-bind:step="step" v-bind:update="false" v-bind:submitted="submitted"
                            v-bind:errors="errors" />
                    </div>
                    <div class="modal-footer">
                        <div class="text-center w-100" v-if="loading">
                            <SpinnerLoading />
                        </div>
                        <button type="submit"
                            class="default-btn transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 fs-md-15 fs-lg-16"
                            v-else>
                            {{ $t('feature.surveys.$steps.save') }}
                        </button>

                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import API from '@/services/api/api.service';
import { Survey, SurveyStep } from '@/utils/models/survey.model';
import { PropType } from 'vue';
import { defineComponent } from 'vue';

import StepForm from "@/components/FK/Surveys/Admin/StepForm.vue";
import SpinnerLoading from "@/components/Widgets/Spinner.vue";
import { clone } from '@/utils/methods/form_utils';
import { i18n } from '@/assets/i18n/i18n';

export default defineComponent({
    props: {
        id: {
            type: String,
            required: true
        },
        survey_id: {
            type: [String, Number],
            required: true
        }
    },
    data() {
        return {
            step: { title: {}, text: {}, body: {}, choices: {} } as SurveyStep,
            submitted: false,
            loading: false,
            errors: undefined as any,
        }
    },
    methods: {
        restoreData() {
            this.resetStep();
            this.submitted = false;
            this.loading = false;
            this.errors = undefined as any;
        },
        resetStep() {
            this.step = { title: {}, text: {}, body: {}, choices: {} } as SurveyStep;
        },
        submit(event) {
            this.errors = undefined;
            this.loading = true;
            event.preventDefault();
            console.log('SUBMIT');
            console.log(this.step);
            API.createSurveyStep({ survey_id: this.survey_id, step: this.step }).then((response) => {
                console.log(response);
                if (response.data.success === true && response.data.data != undefined) {
                    let title = {};
                    let text = {};
                    let body = {};
                    let choices = {};
                    title[i18n.global.locale] = response.data.data.title;
                    text[i18n.global.locale] = response.data.data.text;
                    body[i18n.global.locale] = response.data.data.body;
                    choices[i18n.global.locale] = response.data.data.choices;
                    this.restoreData();
                    this.$emit('save', { ...response.data.data, title: title, text: text, body: body, choices: choices } as SurveyStep);
                } else {
                    throw Error()
                }
            }).catch((error) => {
                this.errors = error.response?.data?.errors;
            }).finally(() => {
                this.loading = false;
            });
        }
    },
    components: {
        SpinnerLoading,
        StepForm
    },
    name: "SurveyStepModal",
});
</script>